
import {SIZE,START_XPOS,START_YPOS,FONT_INDEX,FONT_INDEX_MIN, FONT_INDEX_MAX,
        FS_REG, FS_MED, FS_SMALL} from 'src/app/shared/constant/drawConstants';
import {calcTabPos,tallyLineSymWidths} from 'src/assets/js/cv-helpers.js';
import {DrawToolType} from 'src/app/shared/constant/draw-tool-api'; 
/*
import { CV_SIMPLE_GRP,CV_BRACKET_GRP,CV_SPEC2_GRP, CV_LONG_GRP, CV_BRANCHING_GRP,
         CV_VAR_SQR_TYPE,CV_TRIG_TYPE,CV_SUM_LIMIT_TYPE,CV_LOG_LN_TYPE,CV_UNITS_TYPE,
         CV_VAR_TYPE, KEY_ID_SIN, } from 'src/app/shared/constant/canvasSymTypes';  */

import * as SymConst from 'src/app/shared/constant/canvasSymTypes'; 
import { db, stage } from './draw';

// db stage states
export const STATE_NORMAL = 1;              // used for both db abd problem states
export const STATE_FILE_IMPORT = 2;
export const STATE_OPEN_FILE = 3;
export const STATE_INIT = 4;
export const STATE_IN_DRAG = 5;
export const STATE_IN_ABC = 6;
export const STATE_TEXT_SELECTED = 7;  //may not be used
export const STATE_IN_WHITESPACE_ADD = 21;
export const STATE_IN_PEN_TOOL = 24;
export const STATE_IN_DRAW_MULTI = 25;
export const STATE_VIEW_ONLY_FILE = 26;

// problem states
export const STATE_DRAW_OVERLAY = 10;
export const STATE_CARRY_SYM = 11;
export const STATE_ABC_DRAG = 12;
export const STATE_IN_PROB_SCALE = 13;
export const STATE_ABC_WRAP = 14;
export const STATE_IN_IPAD_ABC = 15;
export const STATE_IN_CLIPBOARD_SELECT  = 19;
export const STATE_IN_GRID_FRACTION_NUM = 21;
export const STATE_IN_GRID_FRACTION_DEN = 22;
export const STATE_CLIPBOARD_SELECT_ICON = 23;
// problem states for branch symbols in A mode
export const STATE_WAIT_ADVANCE = 16;
export const STATE_WAIT_COMPLETE = 17;
export const STATE_ROOT_FIRST = 18;
export const STATE_IN_PASTE = 20;

export const SCALE_INCREMENT = 1.25;
export const OVERLAY_TYPE_LINE = 1;
export const OVERLAY_TYPE_DIVIDE = 2;
export const testbranch = 1;

//export const IMAGE_TYPE_PDF = 1;
//export const IMAGE_TYPE_BITMAP = 2;

// constants to designate the a or aa trait
export const SINGLE_DIGIT_TYPE = 1;
export const MULTI_DIGIT_TYPE = 2;

export class SelectionAreaType {
    constructor(startSIndex,endSIndex, width, height) {
        this.startSIndex = startSIndex;
        this.endSIndex = endSIndex;
        //this.nextSymIndex = startSIndex;
        this.width = width;
        this.height = height;
        this.beginWidth = width;
        this.beginHeight = height;
        this.startX = 0;
        this.endX = 0;
        this.startY = 0;
        this.box = null;
        this.parent = null;          // problem or line container holding this container
        this.inBranch = false;      // flag of whether slection is current within branch of line problem
        this.wasBranch = false;     // flag of whether starting click was in a branch
        this.hasFirstSym = false;   // true if started in branch and includes first symbol of branch - allows copy beyond this branch
        this.endBranch = 0;         // xpos in branch container of the last symbol.
        this.nextSymX = 0;
        this.probStartX = 0;
        this.probEndX = 0;
        this.nextBranchEndX = 0;    // when starting in nexted branch, the next branch out
        this.inNextBranch = false;
        this.startBranch = null;    // in line problems only, show the branch clicked on at start of section
        this.curBranch = null;      // in line problems only, show the most parent branch covered by the selection
        //this.offset = 0;
        this.hasNest = false;
        this.resizeDot = null;      // createjs object for drag dot in the case the user clicked selection area menu icon
    }
}


export class CvDrawingBoard {
    constructor() {
        this.saveTokenExpire = null;
        // these size related fields are set in initSize and not reset on open file rest or undo reset
        this.fontIndex = null;      // index of font used by SIZE constant, not the font size
        this.font = 0;              // font size
        this.prefFont = 8;          // index of font last set by user prefs.  Initiallized to large for some new file cases
        this.gridWidth = null;  
        this.gridHeight = null; 
        
        // these fields do not get changed on open new file db reset or undo reset
        this.inIpad = false;
        this.imageScale = 1;         // shows the scale of an image file, only when tht image file is scaled seperately as first action
        this.newInit = false;       // shows that loadCanvas was since last cvNewFile, shows whether to preserve A flag
        this.isBranchAMode = false;
        this.userPrefs = null;
        this.analytics = null;

        // these field do not get reset on an undo db reset, along with above fields
        this.bitmap = [];
        this.imageSourceFromSplits = [];  // use same index as bitmap to refer to source rec locations after splits
        this.hasSplits = false;

        this.fileImage = null; 
        this.fileCountDown = 0;     // used to determine when last file is loaded on open, to tell when to check for whitespace splits
        this.lastCanvasY = 0;       // for whitespace add pages, a measure of the used space in canvas, as end of the moved images or problems added 
        this.pageCount = 1;
        this.undoStack = [];           
        this.redoStack = [];
        this.clipboard = null;
        this.selectionArea = null;   // describes the area selected for a clipboard copy
        this.userLog = null;
        this.mathFile = null;    // last mathfile given to get file data, not reset for testing purposes 
        this.openedFile = null;  // copy of the math file passed in for open, used for undo as last undo step
        this.mathLevel = 4;  // temporary for testing 
        this.lev3UseGrid = false;
        this.displayType = 0;
        
        this.xpos = START_XPOS;
        this.ypos = START_YPOS;
        this.stageScale = 1;  // might not need this
        this.stageBackground = null;
        this.state = STATE_INIT;
        this.probState = STATE_NORMAL;
        this.inFractions = false;
        this.inUndo = false;
        this.inPen = false;
        this.inOpenViewOnly = false;
        this.fileChanged = false;
        this.ipadDragX = 0;     // this are used just to store the drag container coordinates temporarily 
        this.ipadDragY = 0;     // during a print or export

        // these fields  track the current problem and currently used symbol objects
        this.pIndex = -1;           // current problem index
        this.curProb = null;        // points to the current active problem object, given by db.mProb[db.pIndex]
        this.curLine = 0;           // points to the main line object of the current line of the current active problem
        this.curContainer = null;   // points to the container of the current active problem
        this.curOverlay = null;     // symbol object of most recent overlay (line, divide) symbol
        this.curCrossOff = null;    // symbol object of most recent crossoff symbols  
        this.curText = null;        // text symbol object of the most recent abc text
        this.cursor = null;         // createjs shape for cursor
        this.curBranch = null;      // for DISPLAY_TYPE_LINE problems, the current line or branch
                                    // will be same as curLine when not on a branch from a branching symbol  
        this.pageBreakContainer = null;
        this.stageDragContainer = null;
        // check these might not be used anymore
        this.inTextBox = false;
        this.textTyped = '';         // text string of characters typed by user during inTextbox action
        this.textBox = null;         // createjs box for behind text
        this.textToDraw = null;      // createjs text object
        this.textContainer = null;   // createjs container for drawing textboxes and text

        this.penLayer = null;         // createjs container for entire pen (draw tool) layer
        this.penBackground = null;    // createjs shape as coverup of rest of math problems when in pen mode
        this.pen = null;              // last draw tool object passed to canvas with draw tool settings

        // the shows all the current math problems
        this.mProb = [];             // the array of math problem objects   
        this.penItemList = [];           // the arrow of pen item objects
        this.curPenIndex = -1;          // Index into pen object array of current edited/created pen object
        this.curPenObj = null;          // createjs object of the current pen object shape
        this.curPenContainer = null;    // createjs object of the current pen object container (contains shape)
        this.penMultiTimer = null;
    }

    initSize(fontIndex) {
        // if receive invalid fontIndex, set it to the default size of large
        if (fontIndex < FONT_INDEX_MIN || fontIndex > FONT_INDEX_MAX) {
            fontIndex = 8;
        } 
        this.font = SIZE[fontIndex].font;
        this.fontIndex = fontIndex;
        this.gridWidth = SIZE[fontIndex].gridWidth;
        this.gridHeight = SIZE[fontIndex].gridHeight;
       
    
        // adjust gridWidth for fontSpacing setting
        // This value is used only in grid and text problems,
        // line problems recalulate based on fontIndex and then
        // do calculations within symbol defs
        if (db.userPrefs != null) {
            if (db.userPrefs.fontSpacing == 2) {
                this.gridWidth = this.gridWidth * .8;
                this.gridHeight = this.gridHeight * .85;
            }
            else if (db.userPrefs.fontSpacing == 3) {
                if (db.mathLevel >= 3) {
                    this.gridWidth = this.gridWidth * .7; 
                    this.gridHeight = this.gridHeight *.75;
                }
                else {
                    this.gridWidth = this.gridWidth * .65; 
                    this.gridHeight = this.gridHeight *.7;   
                }
            }
        }
        
        
        this.halfGridWidth = this.gridWidth/2;
        this.halfGridHeight = this.gridHeight/2;
    }

    
    resetDrawingBoard() {      // clear all drawing board variables except font sizes, for starting a new file
    
        this.fileImage = null; 
        this.fileCountDown = 0; 
        this.lastCanvasY = 0;
        this.pageCount = 1;
        this.undoStack = [];           
        this.redoStack = [];
        this.clipboard = null;
        this.userLog = null;
        this.mathFile = null;        // last mathfile given to get file data, not reset for testing purposes 
        this.openedFile = null;
        this.lev3UseGrid = false;
        this.analytics = null;
        
        //this.mathLevel = 2;  // temporary for grid only implementation
        this.displayType = 0;
        this.xpos = START_XPOS;
        this.ypos = START_YPOS;
        this.stageScale = 1;  // might not need this
        this.stageBackground = null;
        this.state = STATE_INIT;
        this.probState = STATE_NORMAL;
        this.inFractions = false;
        this.inUndo = false;
        this.inPen = false;
        this.inOpenViewOnly = false;
        this.fileChanged = false;
        this.bitmap = [];
        this.imageSourceFromSplits = []; 
        this.hasSplits = false;
        //this.isBranchAMode = false;

        // these fields  track the current problem and currently used symbol objects
        this.pIndex = -1;           // current problem index
        this.curProb = null;        // points to the current active problem object, given by db.mProb[db.pIndex]
        this.curLine = 0;           // points to the line object of the current line of the current active problem
        this.curContainer = null;   // points to the container of the current active problem
        this.curOverlay = null;     // symbol object of most recent overlay (line, divide) symbol
        this.curCrossOff = null;    // symbol object of most recent crossoff symbols  
        this.curText = null;        // text symbol object of the most recent abc text
        this.cursor = null;         // createjs shape for cursor
        this.curBranch = null;

        this.pageBreakContainer = null;
        this.stageDragContainer = null;
        // check these might not be used anymore
        this.inTextBox = false;
        this.textTyped = '';         // text string of characters typed by user during inTextbox action
        this.textBox = null;         // createjs box for behind text
        this.textToDraw = null;      // createjs text object
        this.textContainer = null;   // createjs container for drawing textboxes and text

        this.penLayer = null;
        this.penBackground = null;
        this.pen = null;              // last draw tool object passed to canvas with draw tool settings

        // the shows all the current math problems
        this.mProb = []; 
        this.penItemList = []; 
        this.curPenIndex = -1;  
        this.curPenObj = null;          // createjs object for object being currently drawn or edited
        this.curPenContainer = null; 
        this.penMultiTimer = null;
    }

    undoResetDrawingBoard() {      // clear all drawing board variables except font sizes, for starting a new file
      
        this.xpos = START_XPOS;
        this.ypos = START_YPOS;
        this.stageScale = 1;  // might not need this
        this.stageBackground = null;
        this.probState = STATE_NORMAL;
        this.inFractions = false;
        this.fileChanged = false;

        // these fields  track the current problem and currently used symbol objects
        this.pIndex = -1;           // current problem index
        this.curProb = null;        // points to the current active problem object, given by db.mProb[db.pIndex]
        this.curLine = 0;           // points to the line object of the current line of the current active problem
        this.curContainer = null;   // points to the container of the current active problem
        this.curOverlay = null;     // symbol object of most recent overlay (line, divide) symbol
        this.curCrossOff = null;    // symbol object of most recent crossoff symbols  
        this.curText = null;        // text symbol object of the most recent abc text
        this.cursor = null;         // createjs shape for cursor
        this.curBranch = null;      // for DISPLAY_TYPE_LINE problems, the current line or branch
        // will be same as curLine when not on a branch from a branching symbol 
        
        this.pageBreakContainer = null;
        this.stageDragContainer = null;
        // check these might not be used anymore
        this.inTextBox = false;
        this.inPen = false;
        this.inOpenViewOnly = false;
        this.textTyped = '';         // text string of characters typed by user during inTextbox action
        this.textBox = null;         // createjs box for behind text
        this.textToDraw = null;      // createjs text object
        this.textContainer = null;   // createjs container for drawing textboxes and text

        // the shows all the current math problems
        this.mProb = [];   
        this.penItemList = [];
        this.curPenIndex = -1;  
        this.curPenObj = null;  
        this.curPenContainer = null; 
        this.penLayer = null;
        this.penBackground = null;
        this.penMultiTimer = null;
    }

}
/*
export class penItemType {
    constructor () {
        this.points = [];
        this.dt = null; 
        this.x = 0;
        this.y = 0;
        this.circleRadius = 0;
        this.width = 0;
        this.height = 0;
        this.myIndex = -1;
        this.deleted = false;
    }

    clonePen() {
        this.dt = Object.assign({}, db.pen);
    }

    initPenItem(penPt) {
       
        this.points.push(penPt);
        this.clonePen();
        db.penItem.push(this);
    }
}
    */

export class MProbType  {
    constructor(xpos, ypos, displayType, gridW,gridH, fontSize ,fontIndex) {
        this.xpos = xpos;
        this.ypos = ypos;
        this.displayType = displayType;
        this.matchLevel = true;      // set to false when created in an umatching math level that can't be edited
        this.gridW = gridW;
        this.gridH = gridH;
        this.gridInLineW = SIZE[fontIndex].gridWidth;
        this.fontSize = fontSize;  // the font size, not the index
        this.fontIndex = fontIndex;
        this.altFontSize = fontSize;
        this.gridLineIndex = 0;
        
        this.halfGW = gridW/2;
        this.halfGH = gridH/2; 
        this.probScale = 1;
        this.resizedIndex = fontIndex;
        this.deleted = false;
        this.inSumLimit = false;
        this.fracState = STATE_NORMAL;  // used for grid fractions
        this.hasLongDivide = false; // in line problems, long divide problems will have closer line spacing.
        
        this.width = 0;             // length of longest line in problem, in gridUnits, for sizing container and grid
        this.heightAbove = 0;            // height of whole problem when a DISPLAY_TYPE_LINE in pxs, above container.y
        this.heightBelow = gridH;    // height of whole problem of LINE type in pxs, below container.y
        this.paddingHeight = 10;//gridH/2;// gridH; // amount of space between tree type lines, can be smaller if find division sign
        this.widthFromFile = 0;     // problem width retrieved from file
        this.container = null;      //createjs container for this problem, contains a grid and individual text 
        this.gridShape = null;      // createjs shape for drawing a grid
        this.scalingBox = null;     // createjs shape for scale/drag box around problem
        this.backgroundBox = null;  // createjs shape for barely offwhite background to make mouse clicks detectable
        this.outsideGridBox = null;
        this.w = 0;                 // width in px of a text type box
        this.h = 0;                 // height in px of  a text type problem
        this.textSymList = [];
        this.label = [];
        this.labelXOffset = 0;
        this.lIndex = -1;  
        this.tabEqualPos = 0;   // set to a gridUnit value of the last entered = position on the main line
        this.line = [];         // line or main parent line for tree level problems
    }
}


export class MLineType  {
    constructor() {
        this.sIndex = -1;  // not sure if these indexes are needed, start at -1 so can increment to 0 for first time
        this.sym = [];
        this.overlayLine = null;
        this.overlayDiv = [];
        this.lineWidth = 0;         // gridUnits 
        this.hasLineSeg = false;
       

    }

    

}

export const FRACTION_LINE_TYPE = 1;
export const ROOT_LINE_TYPE = 2;

export class FractionRootLine {
    constructor(type,branch,symObj,startPos,width) {
        this.type = type;
        this.branch = branch;      // branch that the line of this fraction is within
        this.symObj = symObj; 
        this.startPos = startPos;      // in gridUnits
        this.width = width;         // in gridUnits
        this.bScale = 1;
        this.growing = true;    // true when this fraction is incomplete and needs line extended with new symbols
    }
}



export class MBranchType extends MLineType {
    constructor(offsetX, offsetY) {
        super(); //sIndex,sym,overlayLine,overlayDiv);
        this.offsetX = 0;   // fractional offset to ypos in gridUnits to draw this branch
        this.offsetY = 0;  // fractional offset in xpos in gridUnits to draw start this branch
        this.bScale = 1;  // scaling factor for font and grid unit size to apply to this branch
        this.isBranch = false;  // flag for whether this line is a branch type or not.
        this.lineHeight = 1;        // gridUnits or coordinates?
        //this.paddingHeight = db.curProb.gridH;       // on main line, height in px  of spacing after this line.  Set different for division problems
        this.bHeightTop = 0;       // in pixels measured as offset from top left, of branches container.y
        this.bHeightBot = 0;
        this.inTop = false; // might not be used
        this.isDeleted = false;
        this.needComplete = false;   // marks a branch in progress needing a complete, used for saving to file
        this.myLine = 0;       // the line this branch belongs too,  0 indicates this is the main line
        this.openLeftParen = -1;    // sIndex of last left parent on main line without right pair, for making parens tall
        this.makeParenTall = false;

        //this.lineLength = 0;        // don't use this instead of lineWidth - check use,?number of symbols, equal to the length of this line
        this.container = null;         // for line type objects, lines each have their own container
        this.branchBackground = null; // createjs shape of the line rectangle, to handle mouse clicks
        this.branchIndex= -1;        // index of which branch of this symbol it is, either first (0) or second (1) or -1 for main
        this.lineID = 0;            // the lIndex that will get to this line, if it's the main line. 
        this.branchID = 0;          // the index of the branch within this line, 0 means main line. 
        //this.parentLine = null;     // for branches, value of parent line
        this.parentIndex = 0;       // for branches, sIndex of branching symbol this branch is from
        this.nextBranchID = 1;      // id for the next branch created, main line is lineID 0
        //this.parentIndex = 0; // lIndex of parent line or branch line where this line starts
        this.parent = null;     // value of parent line (variable, pointer to)
        this.branchSymList = []; // list of syms that can actively growing, fraction or root lines, if it's the main branch
        this.flagHeightsObj = null;
       
    }

    // method to add symbol element to this line at the positon after .this lines sIndex, plus increment sIndex 
    addSym(sym) {

        let widthAdj = 0;
        let parentBranch = this.parent;
        let parentsIndex = this.parentIndex;
        let symShiftNeeded = false;
        let otherIndex;
        let noBranchShift = false;
        let foundShift = false;

        // check if this is a tab, which can only be on the main line
       
        if (sym.tabWidth == 0) {
            this.lineWidth += sym.width ; //* this.bScale;    // increase line width, in gridUnits??
        }
        else {
            this.lineWidth += sym.tabWidth;
        }
        
        this.sIndex++;
        // if the just added symbol is an exponent or something else with an offset to it's container position, then need
        // to subtract this amount from line widths added to parent branches so calulate it
     
        if (this.sIndex == 0 && this.offsetX < 0) {
            widthAdj = this.offsetX*db.curBranch.bScale;
        }
       
    
        // if at end of line, the put on end
        if (this.sIndex == this.sym.length) {
            this.sym[this.sIndex] = sym;
        }
        else {
            // in inserting into middle of this line/branch, then splice in symbol
            this.sym.splice(this.sIndex,0,sym); 
            symShiftNeeded = true;
        }
    
        
        // fix the parentIndexes of any branches to this branch and to the right of it
        for (let k = this.sIndex; k <= this.sym.length-1; k++) {
            if (this.sym[k].groupCode == SymConst.CV_BRANCHING_GRP) {
                for (let j = 1; j <= this.sym[k].branchCount; j++) {
                    var nextBranch = this.sym[k].branch[j-1];
                    if (nextBranch != null) {
                        nextBranch.parentIndex++;
                    }
  
                }
            }
        }
        


        // adjust the widths of all parent branching symbols that are ancestors of this symbol
        // except if there are multiple branches than compare to length of other branches and increase only
        // if this is the larger branch for that symbol (ex, fractions)
        
        let addToBranchIndex; 
       
        let tempBranch = this;
        addToBranchIndex = tempBranch.branchIndex;
        let wtemp;
        let lineIncrease = 0;
      
        // go through and figure out the width adjustments for  parent branching symbols 
        if (parentBranch != null) {
            
            // if ever add as symbol with 3 branches will need to change this
            if (parentBranch.sym[parentsIndex].branchCount>1 && parentBranch.sym[parentsIndex].str != SymConst.KEY_ID_ROOT) {
               otherIndex = (addToBranchIndex == 0) ? 1 : 0;
                
                // limit symbols have 2 branches below branch symbol and need special calculation
                if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_SUMMATION_2) {
     
                    wtemp = tempBranch.lineWidth + parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth; 
                    if (wtemp > parentBranch.sym[parentsIndex].branch[otherIndex].width) {
                        lineIncrease = wtemp - parentBranch.sym[parentsIndex].width;
                        parentBranch.sym[parentsIndex].width = wtemp;
                        foundShift = true;
                    }
                }
                else if (tempBranch.lineWidth > parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth) {
                    
                    // for sum/limits with branches over symbols, take max instead of adding widths
                    if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_SUMMATION_1) {
                        wtemp = ( parentBranch.sym[parentsIndex].width < this.lineWidth) ?
                                        this.lineWidth - parentBranch.sym[parentsIndex].width : 0;
                            parentBranch.sym[parentsIndex].width  += wtemp;
                            lineIncrease = wtemp;
                            foundShift = (wtemp > 0);                                    
                    }
                    
                    else {
                        // for fractions use the branch width to subtract out the width of the original fraction bar
                        
                            // first time fraction is added to, subtract out the original fraction line
                            if (parentBranch.sym[parentsIndex].emptyFraction) {
                                parentBranch.sym[parentsIndex].emptyFraction = false;
                                let tempWidth = parentBranch.sym[parentsIndex].width;
                                parentBranch.sym[parentsIndex].width = Math.max(sym.width,parentBranch.sym[parentsIndex].width); 
                                let increase = parentBranch.sym[parentsIndex].width-tempWidth;
                                foundShift = (increase > 0); 
                                lineIncrease = increase;
                            }
                            else {
                               
                                let otherSideWidth = parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth
                                
                                // check for case where only the difference of the new fraction branch and the other side of fraction
                                // should be added to the fraction symbol width 
                                if (otherSideWidth > 0) {
                                    parentBranch.sym[parentsIndex].width += Math.min(sym.width, 
                                        parentBranch.sym[parentsIndex].branch[addToBranchIndex].lineWidth-otherSideWidth);
                                } 
                                
                                else {
                                    parentBranch.sym[parentsIndex].width += sym.width;
                                }
                                
                                                                                           
                                lineIncrease = sym.width;
                                foundShift = true;
                            }
                            noBranchShift = !foundShift;
                
                    }
                    
                }
                else {
                    // if this was the smaller or two branches on a symbol, then don't shift other branch x coordinates
                    // unless a prior shift was found above
                 
                    if (!foundShift) {
                        noBranchShift = true;
                    }
                  
                }
            }
            else {
                if (!noBranchShift) {
                    // if single branch symbol, then will also have shift except for prior deleted sqrt
                    foundShift = true;

                    // geometry over-line (single-branch symbol using the reserved-placeholder pattern):
                    // the FIRST variable added REPLACES the reserved width instead of adding to it, so a
                    // one-letter segment isn't a grid unit too wide.  Only symbols with emptyFraction set
                    // (currently just the geo over-line) take this path; sqrt/root/exponent are unaffected.
                    if (parentBranch.sym[parentsIndex].emptyFraction) {
                        parentBranch.sym[parentsIndex].emptyFraction = false;
                        let tempWidth = parentBranch.sym[parentsIndex].width;
                        parentBranch.sym[parentsIndex].width = Math.max(sym.width, tempWidth);
                        lineIncrease = parentBranch.sym[parentsIndex].width - tempWidth;
                        foundShift = (lineIncrease > 0);
                        // The first variable REPLACES the reserved unit, so the line didn't actually
                        // grow (lineIncrease 0).  Mirror the fraction path (see noBranchShift above) so
                        // following branch symbols' containers aren't shifted over - otherwise a later
                        // over-line symbol's letters slide right and overlap the next symbol.
                        noBranchShift = !foundShift;
                    }
                    else {
                    // check for a root that had a prior deleted first symbol, with the root line left
                    // for this, subtract out the length of the line before doing rest of width calculation

                    if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_SQRT ||
                        parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_ROOT) {
                            //if (parentBranch.sym[parentsIndex].width > parentBranch.sym[parentsIndex].sqrtMinWidth)
                            if (parentBranch.sym[parentsIndex].deletedWidth != 0) {
                               if (parentBranch.sym[parentsIndex].deletedToMin) {
                                parentBranch.sym[parentsIndex].deletedToMin = false;
                                widthAdj += parentBranch.sym[parentsIndex].deletedWidth + sym.width;
                               }
                               else {
                                widthAdj += parentBranch.sym[parentsIndex].deletedWidth + sym.width;
                               }
                            }
                            parentBranch.sym[parentsIndex].deletedWidth = 0;


                    }

                    let widthIncrease = tempBranch.lineWidth - parentBranch.sym[parentsIndex].width;
                    parentBranch.sym[parentsIndex].width += sym.width+widthAdj;
                    lineIncrease = sym.width+widthAdj;
                    }

                }
            }
            addToBranchIndex = parentBranch.branchIndex;
            otherIndex = (addToBranchIndex == 0) ? 1 : 0;
            parentBranch.lineWidth += lineIncrease;
            
            parentsIndex = parentBranch.parentIndex;
            parentBranch = parentBranch.parent;
            if (parentBranch != null) {
                if (parentBranch.sym[parentsIndex].branchCount>1) {
                    // this isn't accounting for subtracting out the fraction line width of a multiple fraction
                    // later on should add that. 
                    parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth;
                    if (parentBranch.sym[parentsIndex].branch[addToBranchIndex].lineWidth >
                        parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth) {
                         
                            parentBranch.sym[parentsIndex].width += lineIncrease;
                            parentBranch.lineWidth += lineIncrease;
                        }
                }
                else {
                    parentBranch.sym[parentsIndex].width += lineIncrease;
                    parentBranch.lineWidth += lineIncrease; 
                }
            }
            
        }
        
      
        // move over the branch x coordinates of all branches positioned to the upper and right of this symbol
       
        this.moveOverX(sym.width,this.sIndex);   //sym.width*this.bScale,this.sIndex);
        
        // when changes are made within branches, go up the parent branches to find the symbol in the main line
        // branch associated with this symbol, and adust x coordinates of branches after that
        if (this.isBranch && (!noBranchShift)) {
            let parentSym = this.parent.sym[this.parentIndex];
            let parentIndex = this.parentIndex;
            
            parentBranch = this.parent;
            while (parentBranch.isBranch) {
                parentBranch.moveOverX(sym.width,parentIndex,true);  
                parentIndex = parentBranch.parentIndex;
                parentBranch = parentBranch.parent;
            }
        
            parentBranch.moveOverX(sym.width,parentIndex);             
            
        }
        

        // return whether symbols in this line/branch need shifting.  Over line/branch moves must be figured separately
        stage.update();
        symShiftNeeded = symShiftNeeded || foundShift;
        return(symShiftNeeded);
       

    }

    /**
     * recursive routine!
     * traces through the branch given, and each branch off this branch, and moves the branch coordinates over unitWidth
     * to process an add or delete symbol
     */
    
    moveOverX(unitWidth,startIndex,noRecurse) {
 
        for (let i = startIndex+1; i <= this.sym.length-1; i++) {
           
            if (this.sym[i].tabWidth > 0 ) {
              
                if (this.sym[i].tabWidth >= unitWidth) {
                    this.sym[i].tabWidth -= unitWidth;
                    if (this.sym[i].tabWidth == 0) {
                        this.sym[i].tabWidth = TAB_UNIT_WIDTH;
                    }
                }
                else { // if tab is getting smaller than unitWidth or equal, then reset tab to tab size
                    let tally = tallyLineSymWidths(this,i);
                    this.sym[i].tabWidth = calcTabPos(tally);
                }
                
                return;
            }

            if (this.sym[i].groupCode == SymConst.CV_BRANCHING_GRP) {
               
                //check each branching symbol to trace through it's branches

                for (let j = 1; j <= this.sym[i].branchCount; j++) {
                    var nextBranch = this.sym[i].branch[j-1];
                    // adjust the parentIndex since the sIndex position will have changed of it's parent symbol
                    //nextBranch.parentIndex++;
                    // each branching symbol covers the width of it's child branch, so add width of new symbol in- check fractions 
                    //nextBranch.lineWidth += unitWidth;
                    nextBranch.container.x += unitWidth*db.curProb.gridW;  // bscale not right
                
                    if (!noRecurse) {
                    nextBranch.moveOverX(unitWidth,-1);
                    }
                }
            }
        }
        
    }

    


    // method to delete a symbol element from this line. 
    deleteSym(sym, symIndex) {

        let widthAdj = 0;
        let otherIndex;
        let foundShift = false;
        let priorLineWidth = this.lineWidth;
        this.lineWidth -= sym.width; //           // decrease line width, in gridUnits
        let parentBranch = this.parent;
        let parentsIndex = this.parentIndex;
        let symShiftNeeded = false;
        let noBranchShift = false;
        
        // sIndex is not adjusted here, since it depends on which symbols is being deleted (backspace or delete)
       
        
        // if at end of line, the put on end
        if (symIndex == this.sym.length-1) {
            this.sym.pop(); 
        }
        else {
            // in inserting into middle of this line/branch, then splice in symbol
            this.sym.splice(symIndex,1);   // CHECK THIS
            symShiftNeeded = true;
        }
        // fix the parentIndexes of any branches to this branch and to the right of it
        for (let k = this.sIndex+1; k <= this.sym.length-1; k++) {
            
            if (k >= 0 && this.sym[k].groupCode == SymConst.CV_BRANCHING_GRP) {
                for (let j = 1; j <= this.sym[k].branchCount; j++) {
                 
                    var nextBranch = this.sym[k].branch[j-1];
                    if (nextBranch != null) {
                        nextBranch.parentIndex--;
                    }
                
                }
            }
        }
 

        let addToBranchIndex = this.branchIndex;
        let tempBranch = this;
        let wtemp;
        let lineDecrease = 0;

        if (parentBranch != null) {
            // if ever add as symbol with 3 branches will need to change this
            // roots branches are dependent on each other so treat them like single branch symbols
            if (parentBranch.sym[parentsIndex].branchCount>1 && parentBranch.sym[parentsIndex].str != SymConst.KEY_ID_ROOT) {
                otherIndex = (addToBranchIndex == 0) ? 1 : 0;
                let otherBranch = parentBranch.sym[parentsIndex].branch[otherIndex];
                //console.log(otherIndex, tempBranch.lineWidth, parentsIndex,parentBranch.sym[parentsIndex].branch[otherIndex]);
                // limit symbols have 2 branches below branch symbol and need special calculation
                if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_SUMMATION_2) {
                    wtemp = tempBranch.lineWidth + otherBranch.lineWidth; 
                    if (wtemp > parentBranch.sym[otherIndex].width || otherBranch.isDeleted) {
                        lineDecrease = wtemp - parentBranch.sym[parentsIndex].width;
                        //parentBranch.sym[parentsIndex].width = wtemp;
                        //foundShift = true;
                    }
                }
                //since deleting, check if the line width of the branch having the delete BEFORE the delete was
                // the larger one of the the two symbol branches

                // adjust for rounding errors by subtraction -.001
                else if (priorLineWidth-.001 >= parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth ||
                                           otherBranch.isDeleted) {
                   
                    // for sum/limits with branches over symbols, take max instead of adding widths
                    if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_SUMMATION_1) {
                        wtemp = ( priorLineWidth > SUM_BASE_WIDTH+NUM_BASE_WIDTH/2) ? //this.lineWidth) ?
                                        parentBranch.sym[parentsIndex].width - this.lineWidth : 0;
                            parentBranch.sym[parentsIndex].width  -= wtemp;
                            lineDecrease = wtemp;
                            foundShift = (wtemp > 0);                                    
                    }
                    
                    else {    // must be a fraction
                        
                        let tempParentWidth = parentBranch.sym[parentsIndex].width;
                        let otherSideWidth = parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth
                                
                        // check for case where only the difference of the new fraction branch and the other side of fraction
                        // should be subtracated from the fraction symbol width 
                        if (otherSideWidth > 0) {
                            parentBranch.sym[parentsIndex].width -= Math.min(sym.width, 
                                parentBranch.sym[parentsIndex].branch[addToBranchIndex].lineWidth+sym.width-otherSideWidth);
                        } 
                        else {
                            parentBranch.sym[parentsIndex].width -= sym.width; // + widthAdj;
                        }
                        // if delete would bring a fraction below it's minimum starting line size, then leave it to the bigger sizer
                        if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_FRACTION) {
                            parentBranch.sym[parentsIndex].width = Math.max(parentBranch.sym[parentsIndex].width,
                                                                   NUM_BASE_WIDTH*this.bScale);
                            let widthChange = tempParentWidth -parentBranch.sym[parentsIndex].width;
                            lineDecrease = widthChange; 
                            foundShift = (lineDecrease > .001);   // greater than 0 to account for rounding errors
                         
                        }
                        else {
                      
                            lineDecrease = sym.width;
                            foundShift = true;
                        }
                        noBranchShift = !foundShift;
                    }
                    
                }
                else {
                    // if this was the smaller or two branches on a symbol, then don't shift other branch x coordinates
                    // unless a prior shift was found above
                    if (!foundShift) {
                        noBranchShift = true;
                    }
                  
                }
            }
            else {
                if (!noBranchShift) {

                    let stopShift = false;
                    if (parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_SQRT ||
                        parentBranch.sym[parentsIndex].str == SymConst.KEY_ID_ROOT) {
                        //console.log(parentBranch.sym[parentsIndex].sqrtMinWidth, parentBranch.sym[parentsIndex].width,sym.width);
                        if ((parentBranch.sym[parentsIndex].width - sym.width) < parentBranch.sym[parentsIndex].sqrtMinWidth) {
                            parentBranch.sym[parentsIndex].width = parentBranch.sym[parentsIndex].sqrtMinWidth;
                            stopShift = true;
                            parentBranch.sym[parentsIndex].deletedWidth = -parentBranch.sym[parentsIndex].sqrtLineWidth; 
                            parentBranch.sym[parentsIndex].deletedToMin = true;
                        }
                    }
                    if (!stopShift) {
                        parentBranch.sym[parentsIndex].width -= sym.width+widthAdj;  
                        lineDecrease = sym.width+widthAdj;              
                        foundShift = true;
                    }
                }
            }
            
            
            addToBranchIndex = parentBranch.branchIndex;
            otherIndex = (addToBranchIndex == 0) ? 1 : 0;
            parentBranch.lineWidth -= lineDecrease;
            
            parentsIndex = parentBranch.parentIndex;
            parentBranch = parentBranch.parent;
            if (parentBranch != null) {
                if (parentBranch.sym[parentsIndex].branchCount>1) {
                    // this isn't accounting for subtracting out the fraction line width of a multiple fraction
                    // later on should add that. 
                    //parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth;
                    if (parentBranch.sym[parentsIndex].branch[addToBranchIndex].lineWidth >
                        parentBranch.sym[parentsIndex].branch[otherIndex].lineWidth) {
                         
                            parentBranch.sym[parentsIndex].width -= lineDecrease;
                            parentBranch.lineWidth -= lineDecrease;
                        }
                }
                else {
                    parentBranch.sym[parentsIndex].width -= lineDecrease;
                    parentBranch.lineWidth -= lineDecrease; 
                }
            }
            
        }
         // when changes are made within branches, go up the parent branches to find the symbol in the main line
        // branch associated with this symbol, and adust x coordinates of branches after that
        if (this.isBranch  && !noBranchShift) {
            let parentSym = this.parent.sym[this.parentIndex];
            let parentIndex = this.parentIndex;

            parentBranch = this.parent;
           
            while (parentBranch.isBranch) {
                parentBranch.moveOverX(-sym.width,parentIndex,true);  
                parentIndex = parentBranch.parentIndex;
                parentBranch = parentBranch.parent;
            }
        
            parentBranch.moveOverX(-sym.width,parentIndex+1);                 //-sym.width*this.bScale,parentIndex+1);
        }
        
        this.moveOverX(-sym.width,this.sIndex);             //(-sym.width*this.bScale,this.sIndex);
        // return whether symbols in this line/branch need shifting.  Over line/branch moves must be figured separately
    

        symShiftNeeded = symShiftNeeded || foundShift;
    
        return(symShiftNeeded);

    }
}

export class OverlayType {
    constructor(type,start,end) {
        this.type = type;
        this.start = start;     // grid position line starts
        this.end = end;       // grid position line ends
        this.lIndex = -1;
        this.container = null;
        this.lineShape = null;
        this.myProb = null;     // links to the mProb this Overlay belongs to
        this.isActive = true;
    }
}

export class SymbolType {
    constructor(str,type) {
        this.str = str;     // keyID
        this.type = type;
        this.crossOff = null;
        this.crossOffType = 0;
        this.crossOffAddComplete = false;
        this.displayText = null;       // createjs text object for this field or container for fraction
        this.overlay = null;           // link to the overlay start starts at this symbol, for deleting
        this.clipOffset = -1;          // offset used for copy/paste selection
        this.isSelected = false;       // flag for whether symbol is slected for internal clipboard copy 
        this.lineSeg = null;              // line segment drawn below this symbol in grid, createjs shape, null if none
        this.lineSegStart = null;       // createjs shape for line end dot    
        this.lineSegEnd = null;         // createjs shape for line dot
        this.fractionNumStr = '';           // string for fraction numerator value
        this.fractionDenStr = '';            // string for fraction denominator value
        this.fractionNum = null;                // createjs text object for fraction numerator
        this.fractionDen = null;                // createjs text object for fraction denominator
    }
}
export class SymbolSimple extends SymbolType {
    constructor(str,type,displayText) {
        super(str,type,displayText);
        this.width = 1;
    }
}



export const SYM_TYPE_SIMPLE = 1;
export const SYM_TYPE_LONG = 2;
export const SYM_TYPE_TEXT = 3;



export class SymbolText extends SymbolType {
    constructor(str,type) {
        super(str,type);
        this.w = 1;                 // if text wrapped, width of box
        this.h = 1;                 // if text wrapped, height of box
        this.textTyped = '';        // text string of characters typed by user during inTextbox action
        this.box = null;            // createjs box for behind  text and around during ABC
        this.textToDraw = null;     // createjs text object for text
        this.container = null;       // createjs container for the text objects
        this.pIndexReturn = -1;           // problem index of math problem preceding or with this text
        this.pIndex = 0;            // pIndex problem current is on
        this.wrapAllowed = false;    // flags whether this text can be word wrapped and needs event handler 
        this.wrapDot = null;
        this.wrapStarted = false;
        this.lineCount = 1;         /// counts the number of lines based on newline chars plus 1
        this.edgeWrapped = false;
    }
}


export const TAB_UNIT_WIDTH = 3;   // tab every 5 grid units
export const NUM_BASE_WIDTH = .8; // used also in drawing fraction lines
export const SUM_BASE_WIDTH = .9;
export const SQRT_LINE_WIDTH = .8;
export const SQRT_BASE_WIDTH = .9;
export const KEY_ID_ALT_E = "ne";
export class SymbolTree extends SymbolType {
    
    constructor(str,type,groupCode,displayText) {
        super(str,type,displayText);
        this.groupCode = groupCode;
        this.width = 1;
        this.tabWidth = 0;  // value in gridUnits of tab position of this symbol, if tab symbol
        this.symWidth = 1;
        this.symOffsetX = 0;
        this.altStr = false;        // set to true for symbols which have display strings different than key IDs
        this.alt = "";
        this.tabPos = 0;        // 0 signifies no tab
       
    }

    setSymTraits(str,type,groupCode,firstCharFlag) {
      
        switch (groupCode) {

            case SymConst.CV_BRACKET_GRP:
                switch (str) {
                    case SymConst.KEY_ID_PAREN_RIGHT:
                        this.symOffsetX = .1;
                        this.width = .7;
                        this.tall = false;
                        break;
                    case SymConst.KEY_ID_PAREN_LEFT:
                        this.symOffsetX = .2;
                        this.width = .7;
                        this.tall = false;
                        break;
                } 
                this.width = .7;
    
                break;
              
            case SymConst.CV_SIMPLE_GRP:
                if (type == SymConst.CV_NUM_TYPE || (firstCharFlag && type == SymConst.CV_OPERATOR_TYPE)) {
                    this.width = NUM_BASE_WIDTH;
                    this.symOffsetX = .4;
                }
              
                else {
                    switch(str) {
                        case SymConst.KEY_ID_COMMA:
                        case SymConst.KEY_ID_DECIMAL:
                        case SymConst.KEY_ID_ABSOLUTE:
                        //case SymConst.KEY_ID_COLON:
                            this.width = .4;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_E:
                            this.altStr = true;
                            this.alt = KEY_ID_ALT_E;
                            this.width = .8;
                            this.symOffsetX = .2;
                            this.alt
                            break;
                        case SymConst.KEY_ID_TRIANGLE:
                        case SymConst.KEY_ID_GEO_CIRCLE: 
                            this.width = .9;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_ANGLE:
                        case SymConst.KEY_ID_RIGHT_ANGLE:
                            this.width = .6;
                            this.symOffsetX = 0;
                            break;
                        case SymConst.KEY_ID_COLON:
                            this.width = .6;
                            this.symOffsetX = 0;
                            break;
                        case SymConst.KEY_ID_DELTA:
                            this.width = .8;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_ABSOLUTE:
                            this.width = .3;
                            this.symOffsetX = 0;
                            break; 
                        case SymConst.KEY_ID_FACTORIAL:
                            this.width = .6;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_DOUBLE_PRIME:
                            this.width = .5;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_PRIME:
                            this.width = .5;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_I: 
                            this.width = .7;
                            this.symOffsetX = .3; 
                            break;
                        case SymConst.KEY_ID_NEGATIVE_SIGN:
                        case SymConst.KEY_ID_PI:
                        case SymConst.KEY_ID_THEREFORE:
                        case SymConst.KEY_ID_BECAUSE:
                        case SymConst.KEY_ID_PARALLEL:
                        
                            this.width = .8;
                            this.symOffsetX = .2;
                            break;
                        case SymConst.KEY_ID_PERPENDICULAR:
                        case SymConst.KEY_ID_CHEM_ARROW:
                        case SymConst.KEY_ID_LEFT_ARROW:
                        case SymConst.KEY_ID_CHEM_DB_ARROW:
                            this.width = .8;
                            this.symOffsetX = .1;
                            break;
                        case SymConst.KEY_ID_INFINITY:
                            this.width = 1;
                            this.symOffsetX = .2;
                            break;
                        case SymConst.KEY_ID_LIMIT_ARROW:
                            this.width = .6;
                            this.symOffsetX = 0;
                            break;
                        case SymConst.KEY_ID_AVOGADRO:
                            this.alt = SymConst.KEY_ID_AVOGADRO_ALT;
                            this.altStr = true;
                            this.width = 7.7;
                            this.symOffsetX = .2;
                            break;
                        case SymConst.KEY_ID_TAB:
                        case SymConst.KEY_ID_TAB_EQUAL:
                            this.width = 0;
                            this.symOffsetX = 0;
                            this.altStr = true;
                            this.alt = "";
                            break;
                        case SymConst.KEY_ID_SPACE:
                            this.width = NUM_BASE_WIDTH;
                            this.symOffsetX = .4;
                            break;
                         case SymConst.KEY_ID_GEO_CIRCLE:
                            this.width = .8;
                            this.symOffsetX = 0;
                            break;
                        default:
                            this.width = 1;
                            this.symOffsetX = .5;
                            break;
                    }
                }
                break;
            case SymConst.CV_SPEC2_GRP:
                if (type == SymConst.CV_ABC_TYPE) { // misc letter keys from keyboard, need to be centered
                    this.width = NUM_BASE_WIDTH;
                    if  (/^[A-Z]$/.test(str)) {
                        this.symOffsetX = .1;
                    }
                    else {
                        this.symOffsetX = .2;
                    }
                }
                else if (str == SymConst.KEY_ID_LINE) { // space key
                    this.width = 1.6;
                    this.altStr = true;
                    this.alt = SymConst.KEY_ID_LONG_LINE_SEGMENT;
                    } 
                else {  
                    this.width = .8;
                    this.symOffsetX = .4;  
                }
                break;
        
            case SymConst.CV_LONG_GRP:
                
                if (str.length == 1 && (type != SymConst.CV_UNITS_TYPE && type != SymConst.CV_TEXT_TO_LINE)) {
                    if (str == SymConst.KEY_ID_M) {
                        this.width = 1.0;
                    }
                    else {
                        this.width = NUM_BASE_WIDTH;
                    }
                    if  (/^[A-Z]$/.test(str) || str == SymConst.KEY_ID_THETA) {
                        this.symOffsetX = .1;
                    }
                    else {
                        this.symOffsetX = .2;
                    }
                    
                }
                else {
                    switch (type) {    
                        case SymConst.CV_GEO_SYMBOL:
                            if (str == SymConst.KEY_ID_MEASURE_ANGLE) {
                                this.width = 1.7;
                                this.symOffsetX = .2;
                            }
                        break;
                        case SymConst.CV_VAR_TYPE:
                            if (str == SymConst.KEY_ID_FX) {
                                this.width = 1.6;
                                this.symOffsetX = .2;
                            }
                        break;
                        case SymConst.CV_VAR_SQR_TYPE:
                            this.width = 1.3;
                            this.symOffsetX = .2  
                            break;
                        case SymConst.CV_TRIG_TYPE:
                            switch(str) {
                                case SymConst.KEY_ID_INVERSE_SIN:
                                case SymConst.KEY_ID_INVERSE_TAN:
                                case SymConst.KEY_ID_INVERSE_COS:
                                case SymConst.KEY_ID_INVERSE_SEC:
                                case SymConst.KEY_ID_INVERSE_COT:
                                case SymConst.KEY_ID_INVERSE_CSC:
                                    this.width = 2.4;
                                    this.symOffsetX = .2;
                                    break;
                                case SymConst.KEY_ID_SIN_SQR:
                                case SymConst.KEY_ID_COS_SQR:
                                case SymConst.KEY_ID_TAN_SQR:
                                case SymConst.KEY_ID_CSC_SQR:
                                case SymConst.KEY_ID_SEC_SQR:
                                case SymConst.KEY_ID_COT_SQR:
                                    this.width = 2;
                                    this.symOffsetX = .2;
                                    break;
                                case SymConst.KEY_ID_SIN:
                                case SymConst.KEY_ID_COS:
                                case SymConst.KEY_ID_TAN:
                                case SymConst.KEY_ID_CSC:
                                case SymConst.KEY_ID_SEC:
                                case SymConst.KEY_ID_COT:
                                    /*
                                    switch (db.userPrefs.fontSpacing) {
                                        case FS_REG: 
                                            this.width = 1.5;
                                            break;
                                        case FS_MED:
                                            this.width = 1.7;
                                            break;
                                        case FS_SMALL:
                                            this.width = 2.0;
                                            break;
                                    }
                                    */
                                    this.width = 1.6;
                                    this.symOffsetX = .2;
                                    break;
                            }
                            break;
                        case SymConst.CV_LOG_LN_TYPE:
                            switch(str) {
                                case SymConst.KEY_ID_LN:
                                    this.width = 1.1;
                                    this.symOffsetX = .2;
                                    break;
                                default:
                                case SymConst.KEY_ID_LOG:
                                    this.width = 1.6;
                                    this.symOffsetX = .2;
                                    break;
                                case SymConst.KEY_ID_LOG_A:
                                    this.altStr = true;
                                    this.alt = SymConst.KEY_ID_LOG;
                                    this.width = 1.5;
                                    this.symOffsetX = .2;
                                    break;
                            }
                            break;
                        case SymConst.CV_TEXT_TO_LINE:
                            this.symOffsetX = 0;
                            this.width = 0;
                           
                            break;
                        case SymConst.CV_UNITS_TYPE: 
                            switch(str) {
                                // temp switched for euro/lb
                              
                                case SymConst.KEY_ID_MM:
                                //case SymConst.KEY_ID_AM:
                                //case SymConst.KEY_ID_PM:
                                    this.width = 2;
                                    this.symOffsetX = .2;
                                    break;
                                case SymConst.KEY_ID_CM_CUBE:
                                case SymConst.KEY_ID_CM_SQR:
                                    this.width = 2;
                                    this.symOffsetX = 0;
                                   break;
                                case SymConst.KEY_ID_KM:
                                case SymConst.KEY_ID_CM:
                                case SymConst.KEY_ID_OUNCE:  
                                case SymConst.KEY_ID_M_SQR:      
                                    this.width = 1.6;
                                    this.symOffsetX = .2;
                                    break;
                                case SymConst.KEY_ID_U:
                                    this.width = .8;
                                    this.symOffsetX = .2;
                                    break;
                                case SymConst.KEY_ID_IN_CUBE:
                                case SymConst.KEY_ID_IN_SQR:
                                case SymConst.KEY_ID_FT_SQR:
                                 
                                case SymConst.KEY_ID_OUNCE:
                                    this.width = 1.6;
                                    this.symOffsetX = .2;
                                    break;    
                                case SymConst.KEY_ID_FT_MARK:
                                    this.width = .3;
                                    this.symOffsetX = 0;
                                    break;
                                case SymConst.KEY_ID_IN_MARK:
                                    this.width = .4;
                                    this.symOffsetX = 0;
                                    break;
                                case SymConst.KEY_ID_DOLLAR:
                                case SymConst.KEY_ID_L:
                                    this.width = .7;
                                    this.symOffsetX = .1;
                                    break;
                                case SymConst.KEY_ID_M:
                                    this.width = 1.1;
                                    this.symOffsetX = .1;
                                    break;
                                case SymConst.KEY_ID_DEGREE:
        
                                default:        // single character units without special alignments
                                    if (str.length == 1) {
                                            this.width = 1;
                                        this.symOffsetX = .4;
                                    }
                                    else {
                                        this.width = 1.2;
                                        this.symOffsetX = .2;
                                    }
                                    break;
                            }
                        break;
                        case SymConst.CV_DERIVATIVE_TYPE: 
                        switch(str) {
                            case SymConst.KEY_ID_DER_D:
                                this.altStr = true;
                                this.alt = "d"; 
                                this.width = .7;
                                this.symOffsetX = .2;
                            break;
                            case SymConst.KEY_ID_DER_D_SQR:
                                this.width = 1.1;
                                this.symOffsetX = .2;
                            break;
                            case SymConst.KEY_ID_DER_F2:
                                this.width = 1.0;
                                this.symOffsetX = .2;
                            break;
                            case SymConst.KEY_ID_DER_F:
                                this.width = .9;
                                this.symOffsetX = .2;
                            break;
                            case SymConst.KEY_ID_DT:
                                this.width = 1.2;
                                this.symOffsetX = .2;
                            break;
                            case SymConst.KEY_ID_DX:
                            case SymConst.KEY_ID_DY:
                            default:
                                this.width = 1.4;
                                this.symOffsetX = .2;
                            break;
                            
                        }
                        break;
                        default:
                            this.width = 8;
                            this.symOffsetX = .2;
                            break;
                    } 
                }
                break;
            case SymConst.CV_BRANCHING_GRP:
                this.width = -1;
                this.symOffsetX = 0;
                break;
            default:
                this.width = 1;
                this.symOffsetX = .5;
                break;
        }

        //if (this.width > 1) {
            switch (db.userPrefs.fontSpacing) {
                case FS_REG: 
                    break;
                case FS_MED:
                    this.width = this.width -.1;
                    break;
                case FS_SMALL:
                    /*
                    if (this.width < 1.4) {
                        this.width = this.width + (this.width-.8)*.8;
                    }

                    else if (this.width < 2) {
                        this.width = this.width + (this.width-.8)*.5;
                    }
                    else if (this.width < 3) {
                        this.width = this.width + (this.width-.8)*.6;
                    }
                    else {
                        this.width = this.width + (this.width-.8)*.5;
                    }
                    */
                    this.width = this.width - .2; //this.width * .2;
                
                   
                    break;
            }
        //}
      
        this.width = this.width*db.curBranch.bScale;
        this.symWidth = this.width; 
       
    }  
    
   
}
export class SymbolBranching extends SymbolTree {  // include crossOff?
    constructor(str,type,groupCode,displayText) {
        super(str,type,displayText);
        this.groupCode = groupCode;
        this.width = 1;     // width in grid units, including decimals, of this symbol
        this.branch = [];   // array of lines, up to 2
        this.bOffsetX = [];    // fraction indicating X offset of start of branch in gridUnits
        this.bOffsetY = [];    // fraction indicating Y offset of branch in gridUnits
        this.bScale = .5;       // font scale factor branches of this symbol 
        this.branchCount = 1;   // number of branches this symbol has
        this.symOffsetX = 0;
        this.symHeightTop = .5;
        this.symHeightBot = .5;
        this.tall = false;      // for tall symbols such as summation
        this.startPos = 0;      // for growing symbols of sqrt,div,fraction, line
        this.growing = false;   // for growing symbols
        this.growType = 0;      // shows type of line, might not be needed (sym type)
        this.parentBranch = null;      // the branch that created this symbol, db.CurBranch when created
        //this.zeroStartWidth = false;  // used to determine when to delete branch symbol
        this.isStartWidth = true;
       // this.extraWidth = 0;        // extra amount in gridunits that this symbol takes up, like the sqrt sign itself
        this.emptyFraction = false;
    }
    setSymTraits(str) {
      
        switch (str) {
            case SymConst.KEY_ID_GEO_LINE_SEG:
            case SymConst.KEY_ID_GEO_RAY:
            case SymConst.KEY_ID_GEO_LINE:
            case SymConst.KEY_ID_GEO_ARC:
                // geometry over-line: a single full-size branch holds the variables (A, B, ...),
                // with a horizontal line drawn above it (see cv-line-entry.drawGeoOverline).
                // Unlike sqrt/exponent, the branch is NOT scaled or offset - letters sit inline.
                this.branchCount = 1;
                this.bScale = 1;            // full-size letters
                this.bOffsetX[0] = 0;
                this.bOffsetY[0] = 0;
                this.symOffsetX = 0;
                this.width = 1;             // reserve one grid unit so inserting an (empty) symbol makes room right away
                this.emptyFraction = true;  // first variable added REPLACES this reserved width instead of adding to it
                break;
            case SymConst.KEY_ID_FRACTION:
                this.branchCount = 2;
                //this.zeroStartWidth = true;
                if (db.curBranch.branchID == 0)  {// fraction off the main branch
                    /*
                    if (db.userPrefs.fonSpacing <=2) {
                        this.bOffsetX[0] = 0; 
                        this.bOffsetX[1] = 0; 
                        this.width = NUM_BASE_WIDTH; 
                    }
                    else {
                        this.bOffsetX[0] = .1; 
                        this.bOffsetX[1] = .1; 
                        this.width = NUM_BASE_WIDTH-.1; 
                    }
                    */
                    this.bOffsetX[0] = 0; 
                    this.bOffsetY[0] = -.4;
                    this.bOffsetX[1] = 0; 
                    this.bOffsetY[1] = .4;
                    this.bScale = 1; 
                    this.symHeightTop = 2;
                    this.symHeightBot = 1;
                    this.width = NUM_BASE_WIDTH;
                    this.emptyFraction = true;
                } 
                else {
                    this.bOffsetX[0] = 0; 
                    this.bOffsetY[0] = 0;
                    this.bOffsetX[1] = 0; 
                    this.bOffsetY[1] = .4;
                    this.bScale = .5; 
                    this.symHeightTop = .5;
                    this.symHeightBot = .5;
                    this.width = .4; //NUM_BASE_WIDTH*db.curBranch.bScale; 
                    this.emptyFraction = true;
                }
                
                break;
            case SymConst.KEY_ID_EXPONENT:
                //this.zeroStartWidth = true;
                if (db.curBranch.branchID == 0) {
                    this.branchCount = 1;
                    if (db.userPrefs.fonSpacing <=2) {
                        this.bOffsetX[0] = -.2; 
                    }
                    else {
                        this.bOffsetX[0] = -.1; 
                    }
                    this.bOffsetY[0] = -.2; 
                    this.bScale = .8; 
                    this.width = 0;
                    this.symHeightTop = 1;
                }
                else {
                    this.branchCount = 1;
                    if (db.userPrefs.fonSpacing <=2) {
                        this.bOffsetX[0] = -.2; 
                    }
                    else {
                        this.bOffsetX[0] = -.1; 
                    }
                    this.bOffsetY[0] = 0; 
                    this.bScale = .6; 
                    this.width = 0;
                    this.symHeightTop = 1;
                }
                break;
            case SymConst.KEY_ID_EXPONENT_1: // subscript
            //this.zeroStartWidth = true;
                if (db.curBranch.branchID == 0) {
                    this.branchCount = 1;
                    if (db.userPrefs.fonSpacing <=2) {
                        this.bOffsetX[0] = -.2; 
                    }
                    else {
                        this.bOffsetX[0] = -.1; 
                    }
                    this.bOffsetY[0] = .3; 
                    this.bScale = .8; 
                    this.symHeightBot = 1;
                    this.width = 0;
                    break;
                }
                else {
                    this.branchCount = 1;
                    if (db.userPrefs.fonSpacing <=2) {
                        this.bOffsetX[0] = -.2; 
                    }
                    else {
                        this.bOffsetX[0] = -.1; 
                    }
                    this.bOffsetY[0] = .3; 
                    this.bScale = .7; 
                    this.width = 0;
                    this.symHeightTop = 1;
                }
                break;
            case SymConst.KEY_ID_EXPONENT_2: 
                //this.zeroStartWidth = true;
                break;
            case SymConst.KEY_ID_LOG_A:
                this.altStr = true;
                this.alt = SymConst.KEY_ID_LOG;
                this.branchCount = 1;
                this.bOffsetX[0] = 1.4;
                this.bOffsetY[0] = .4; 
                this.bScale = .8; 
                this.width = 1.4;
                this.symOffsetX = .2;
                break;
            case SymConst.KEY_ID_SQRT:
                this.branchCount = 1;
                if (db.curBranch.branchID == 0) { // sqrt on the main branch
                    this.bOffsetX[0] = 0; 
                    this.bOffsetY[0] = 0; 
                    this.bScale = 1; 
                    this.width = SQRT_BASE_WIDTH + SQRT_LINE_WIDTH; 
                    this.sqrtMinWidth = this.width;
                    this.sqrtLineWidth = SQRT_LINE_WIDTH;
                    this.deletedWidth = -SQRT_LINE_WIDTH;
                    this.deletedToMin = false;  // set when delete caused length to be set to min length;
                    //this.symHeightTop = 1.2;
                }
                else {
                    this.bOffsetX[0] = 0; 
                    this.bOffsetY[0] = .1; 
                    this.bScale = .8; 
                    this.width = .8 + SQRT_LINE_WIDTH*this.bScale;
                    this.sqrtMinWidth = this.width + SQRT_LINE_WIDTH*this.bScale-.01;
                    this.sqrtLineWidth = SQRT_LINE_WIDTH*this.bScale;
                    this.deletedWidth = -SQRT_LINE_WIDTH*this.bScale;
                    this.deletedToMin = false;  // set when delete caused length to be set to min length;
                    //this.extraWidth = .8*db.curBranch.bScale;
                }
                break;
            
                case SymConst.KEY_ID_ROOT:
                    this.branchCount = 2;
                    if (db.curBranch.branchID == 0) { // root on the main branch
                        this.bOffsetX[0] = 0; 
                        this.bOffsetY[0] = -.4; 
                        this.bOffsetX[1] = .9; 
                        this.bOffsetY[1] = 0; 
                        this.bScale = 1; 
                        this.width = SQRT_BASE_WIDTH + SQRT_LINE_WIDTH; 
                        this.sqrtMinWidth = this.width;
                        this.sqrtLineWidth = SQRT_LINE_WIDTH;
                        this.deletedWidth = -SQRT_LINE_WIDTH;
                       // this.extraWidth = 1.1;
                    }
                    else {
                        this.bOffsetX[0] = 0; 
                        this.bOffsetY[0] = -.2; 
                        this.bOffsetX[1] = .7; 
                        this.bOffsetY[1] = .1; 
                        this.bScale = .8; 
                        this.width = .8 + SQRT_LINE_WIDTH*this.bScale;
                        this.sqrtMinWidth = this.width + SQRT_LINE_WIDTH*this.bScale-.01;
                        this.sqrtLineWidth = SQRT_LINE_WIDTH*this.bScale;
                        this.deletedWidth = -SQRT_LINE_WIDTH*this.bScale;
                       // this.extraWidth = .8*db.curBranch.bScale;
                    }
                    break;
    
            
            case SymConst.KEY_ID_DIVISION:
                this.branchCount = 2;
                this.bOffsetX[0] = .8; //.2; 
                this.bOffsetY[0] = 0; 
                this.bOffsetX[1] = .8; //.2; 
                this.bOffsetY[1] = -.8; 
                this.bScale = 1; 
                this.width = SQRT_BASE_WIDTH + SQRT_LINE_WIDTH;//.9;//.7; //.4;
                this.symOffsetX = .3;
                break;
            case SymConst.KEY_ID_E_EXPONENT:
                this.altStr = true;
                this.alt = SymConst.KEY_ID_E;
                this.branchCount = 1;
                this.bOffsetX[0] = .5;
                this.bOffsetY[0] = -.2; 
                this.bScale = .8; 
                this.width = .5;
                break;
            case SymConst.KEY_ID_SUMMATION:
                this.branchCount = 0;
                this.tall = true;
                this.width = 1.2;
                break;
            case SymConst.KEY_ID_SUMMATION_1:
                this.altStr = true;
                this.alt = SymConst.KEY_ID_SUMMATION;
                this.tall = true;
                this.branchCount = 2;
                this.bOffsetX[0] = -.1; 
                this.bOffsetY[0] = -.5;
                this.bOffsetX[1] = -.3; 
                this.bOffsetY[1] = .8;
                this.bScale = .7;
                this.width = SUM_BASE_WIDTH;
                // consider "compress" problem state or overlap problem state
                break;
            case SymConst.KEY_ID_SUMMATION_2:
                this.branchCount = 2;
                this.altStr = true;
                this.alt = "lim";
                this.branchCount = 2;
                this.bOffsetX[0] = -.2; 
                this.bOffsetY[0] =  .6;
                this.bOffsetX[1] = -.2; //.5; //.5;set to same as branch 1 because it is changed later based on length
                this.bOffsetY[1] = .6;
                this.bScale = .7;
                this.width = 1.5;
                // consider "arrow" as added to first element of second branch automatically on advance
                break;

            case SymConst.KEY_ID_INTEGRAL:
                this.branchCount = 0;
                this.tall = true;
                this.width = 1;
                this.symOffsetX = .5;
                break;
            case SymConst.KEY_ID_INTEGRAL_1:
                this.altStr = true;
                this.alt = SymConst.KEY_ID_INTEGRAL;
                this.tall = true;
                this.symOffsetX = 0;
                this.branchCount = 2;
                this.bOffsetX[0] = .9; 
                this.bOffsetY[0] = -.5;
                this.bOffsetX[1] = .5; 
                this.bOffsetY[1] = .7;
                this.bScale = .7;
                this.width = .8;
                 break;
            case SymConst.KEY_ID_VERTICAL_LINE:
                this.altStr = true;
                this.alt = SymConst.KEY_ID_ABSOLUTE;
                this.tall = true;
                this.symOffsetX = 0;
                this.branchCount = 2;
                this.bOffsetX[0] = .5; 
                this.bOffsetY[0] = -.4;
                this.bOffsetX[1] = .5; 
                this.bOffsetY[1] = .7;
                this.bScale = .7;
                this.width = .8;
                 break;
            case SymConst.KEY_ID_DER_1:
            case SymConst.KEY_ID_DER_2:
            case SymConst.KEY_ID_DER_3:    
                 this.bOffsetX[0] = 0; 
                 this.bOffsetY[0] = -.4;
                 this.bOffsetX[1] = 0; 
                 this.bOffsetY[1] = .4;
                 this.bScale = 1; 
                 this.symHeightTop = 2;
                 this.symHeightBot = 1;
                 this.width = .8;  //NUM_BASE_WIDTH;
                 break;
            case SymConst.KEY_ID_DER_4:
            case SymConst.KEY_ID_DER_5:
            case SymConst.KEY_ID_DER_6:
            case SymConst.KEY_ID_DER_7:
                 this.bOffsetX[0] = 0; 
                 this.bOffsetY[0] = -.4;
                 this.bOffsetX[1] = 0; 
                 this.bOffsetY[1] = .4;
                 this.bScale = 1; 
                 this.symHeightTop = 2;
                 this.symHeightBot = 1;
                 this.width = 1.4;  //NUM_BASE_WIDTH;
                 break;       
                 

        }
    this.width = this.width*db.curBranch.bScale;
    this.symWidth = this.width; 
    }
    
    
}
